<div class="d-grid gap-3 h-100" [class.grid-2-col]="compactStyle()">
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>{{ customLabel() }}</mat-label>
    <input type="text" matInput [matAutocomplete]="auto" name="businessId" [(ngModel)]="businessId" [value]="displayBusinessName(businessId())" (input)="filterOptions($event.target.value)" (focus)="filterOptions($event.target.value)" (blur)="validateSelection($event.target.value)" [readonly]="lockSelection()" required />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayBusinessName" [requireSelection]="true" (optionSelected)="onOptionSelected($event.option.value)">
      @for (b of filteredBusinessList(); track b.Id) {
        <mat-option [value]="b.Id">{{ b.Name }}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
@if (compactStyle()) {
  <mat-form-field class="flex-fill" subscriptSizing="dynamic">
    <mat-label>Branch</mat-label>
    <mat-select [(ngModel)]="branchId" required>
    @let branch = branchMap().get(branchId());
    <mat-select-trigger>{{ branch?.Name.length > 0 ? branch.Name : branch?.Address.City }}</mat-select-trigger>
  @for (l of branchByBusiness().get(businessId()); track l.Id) {
    <mat-option class="p-2" [value]="l.Id">
          <div class="fw-semibold">{{ l.Name }}</div>
          <div class="text-secondary">{{ l.FullAddress }}</div>
    </mat-option>
  }
    </mat-select>
  </mat-form-field>
} @else if (!businessOnly() && businessId() !== undefined) {
  <table class="table">
    <thead>
      <tr>
      @if (!displayBranchOnly()) {
        <th></th>
      }
        <th>Branch</th>
        <th>Contact</th>
        <th>Address</th>
        <th>Validity</th>
      </tr>
    </thead>
    <tbody>
    @for (b of businessLicenseList()[businessId()]; track b.Id) {
      <tr class="bg-body-secondary">
      @if (!displayBranchOnly()) {
        <td>
          <div class="form-check">
            <input type="checkbox" class="form-check-input" name="branch" (change)="selectBranch($event, b.BranchId)" [checked]="branchId() === b.BranchId" [disabled]="(branchId() && branchId() !== b.BranchId) || lockSelection() || (disableNoLicenseBranch() && b.ValidSince === undefined)" />
          </div>
        </td>
      }
        <td>{{ b.BranchName }}</td>
        <td>
          {{ b.ContactNo }}
          @if (b.Email) {
            <br />{{ b.Email }}
          }
        </td>
        <td>{{ b.FullAddress }}</td>
      @if (b.ValidSince && b.ValidUntil) {
        <td>{{ b.ValidSince | date: "dd MMM yyyy" }} - {{ b.ValidUntil | date: "dd MMM yyyy" }}</td>
      } @else {
        <td><span class="badge text-bg-danger"><i class="fas fa-exclamation-triangle"></i> No Active License</span></td>
      }
      </tr>
    }
    </tbody>
  </table>
}
</div>
